var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.makeSafeForCSS(_vm.$route.name),attrs:{"id":"app"}},[_c('Layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }